/**
 * Convert a string to snake case, e.g. "Your text" -> "your_text"
 * @param text
 */
export function snakeCaseFormat(text: string): string {
  return text.toLowerCase().replace(/\s+/g, "_")
}
